import React from "react"
import { Box } from "@mui/material"

import { AppDialogCancel, AppFormDrawer, AppFormGrid, AppFormSection } from "@components"
import { isEditUserSettingsSitesDrawer, isOpenUserSettingsSitesDrawer, userSettingSitesFormData } from "../../../@signals"
import UserSettingSiteDrawerColor from "./Color"
import UserSettingSiteDrawerSites from "./Sites"
import UserSettingSiteDrawerSubmit from "./Submit"


export default function UserSettingSiteDrawer() {
	const onClose = () => userSettingSitesFormData.value = { }

	return <AppFormDrawer
		icon="palette"
		title={isEditUserSettingsSitesDrawer.value ? 'Edit site' : 'New site'}
		subtitle="A site and its colour"
		isOpen={isOpenUserSettingsSitesDrawer.value}
		controller={onClose}
		footer={<>
			<AppDialogCancel onClick={onClose}/>
			<UserSettingSiteDrawerSubmit/>
		</>}
	>
		<AppFormSection icon="palette" title="Site">
			<AppFormGrid>
				<Box sx={{ gridColumn: 'span 12' }}><UserSettingSiteDrawerSites/></Box>
				<Box sx={{ gridColumn: 'span 12' }}><UserSettingSiteDrawerColor/></Box>
			</AppFormGrid>
		</AppFormSection>
	</AppFormDrawer>
}
